import { MapApi } from 'shared/types';

import { atom } from 'nanostores';

export const $transitioningToMap = atom(true);

export const $currentMap = atom<MapApi>();

export const $gameActive = atom(true);
